<template>
    <module-box :class="'md-featured-area-explore-listings ' + theme">
        <exploreListings
            :theme="theme"
            :keywords="location"
            :breadCrumbs="breadCrumbs"
            :averageData="averageData"
            class="broker-listing-list"
        />
    </module-box>
</template>
<script>
import common from '..';
export default {
    mixins: [common]
};
</script>
